import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Select from './Select';

const NumberSelect = ({ name, props, reference }) => {
    const [selectProps, setSelectProps] = useState({ ...props, options: [] });
    const {
        getValues,
        selectedValues,
        setValue,
        watch,
        // wrap
    } = useFormContext();
    const { referenceField, referenceKey } = reference || {};

    useEffect(
        () => {
            const value = getValues(name);
            const ref = !!referenceField && selectedValues[referenceField];
            const splitKey = referenceKey?.split('.');
            const referenceValue = referenceKey ? splitKey.reduce((acc, key) => acc?.[key], ref) : ref;

            const referenceValInt = parseInt(referenceValue);
            const valueInt = parseInt(value);
            if (!Number.isNaN(referenceValInt) || !Number.isNaN(valueInt)) {
                if (valueInt > referenceValInt) {
                    setValue(name, null);
                }
                // Form up options array [{ id: '1', name: '1' }, { id: '2', name: '2' }, ...]
                // Number of options is either the reference value or the field's default value
                const options = Array.from(Array(referenceValInt || valueInt), (_e, i) => ({ id: (i + 1).toString(), name: (i + 1).toString() }));
                setSelectProps((prev) => ({ ...prev, options }));
            }
        },
        !!referenceField ? [...watch([referenceField])] : []
    );

    return (
        <Select
            name={name}
            props={{ ...selectProps }}
            loading={!selectProps.options.length}
            // wrap
        />
    );
};

export default NumberSelect;
